export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      notices: [
        {
          noticeId: 3,
          noticeUuid: "notice003",
          deliveryAt: 1234567890123,
          deliveryType: "アンケート",
          deliveryTo: ["全配信"],
          noticeStatus: 1,
          noticeContents: "地元の名産品について",
          noticeSenderName: "アイラ地域サポート",
        },
        {
          noticeId: 2,
          noticeUuid: "notice002",
          deliveryAt: 1234567890123,
          deliveryType: "音声定時放送",
          deliveryTo: ["地区：A地区", "地区：B地区"],
          noticeStatus: 0,
          noticeContents: "音声定時放送",
          noticeSenderName: "アイラ地域サポート",
        },
        {
          noticeId: 1,
          noticeUuid: "notice001",
          deliveryAt: 1234567890123,
          deliveryType: "お知らせ",
          deliveryTo: ["全配信"],
          noticeStatus: 1,
          noticeContents: "〇〇大会延期のお知らせ",
          noticeSenderName: "アイラ地域サポート",
        }
      ]
    }
  }
}